import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import BackToTop from '@/components/feature/BackToTop';
import HeroSection from '@/pages/home/components/HeroSection';
import NewsTicker from '@/pages/home/components/NewsTicker';
import HotBoard from '@/pages/home/components/HotBoard';
import CategoryStrip from '@/pages/home/components/CategoryStrip';
import LatestArticles from '@/pages/home/components/LatestArticles';
import CommunityTeaser from '@/pages/home/components/CommunityTeaser';
import FaqPreview from '@/pages/home/components/FaqPreview';

export default function Home() {
  return (
    <div className="page-enter min-h-screen bg-background-50">
      <title>爆瓜福利 - 吃瓜爆料与分享社区 | 最新娱乐八卦资讯</title>
      <meta
        name="description"
        content="爆瓜福利是聚焦娱乐吃瓜的资讯与分享社区，聚合最新爆料、明星动态、影视综艺热议，并提供分享帖、分享群、分享链接与分享码资源合集，加入爆瓜福利分享群获取一手资源，吃瓜更畅快。"
      />
      <meta
        name="keywords"
        content="爆瓜福利,爆瓜福利分享帖,爆瓜福利分享群,爆瓜福利分享链接,爆瓜福利分享码,娱乐吃瓜资讯"
      />

      <SiteHeader />
      <main>
        <HeroSection />
        <NewsTicker />
        <HotBoard />
        <CategoryStrip />
        <LatestArticles />
        <CommunityTeaser />
        <FaqPreview />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}